// deps
import styled, { DefaultTheme } from "styled-components";

// internal-deps
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

const TIMELINE_STEPPER_IMAGE_DIMENSIONS = {
    HEIGHT: "74px",
    WIDTH: "15px",
};

export const TimelineContainer = styled.div.attrs((props: { show: boolean; theme: DefaultTheme }) => props)`
    display: flex;
    padding: ${props =>
        `${props.theme.spacing.xLarge} ${props.theme.spacing.xLarge} ${props.theme.spacing.xLarge} ${props.theme.spacing.large}`};
    border: ${props => `1px solid ${props.theme.colors.light.border_Secondary}`};
    border-radius: ${props => props.theme.cornerRadius.medium};
    position: absolute;
    top: 45%;
    visibility: ${props => (props.show ? "visible" : "hidden")};
`;

export const ImageContainer = styled.div(({ theme }) => ({
    margin: `${theme.spacing.xxSmall} ${theme.spacing.medium} 0 0`,
}));

export const TimelineImage = styled(Image)`
    height: ${TIMELINE_STEPPER_IMAGE_DIMENSIONS.HEIGHT};
    width: ${TIMELINE_STEPPER_IMAGE_DIMENSIONS.WIDTH};
    object-fit: fill;
`;

export const CurrentStateText = styled(Text)(({ theme }) => ({
    padding: `0 ${theme.spacing.large} ${theme.spacing.small} 0`,
    borderBottom: `1px dashed ${theme.colors.light.border_Secondary}`,
    marginBottom: theme.spacing.large,
}));

export const TimelineContent = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: `${theme.spacing.xxxSmall} 0`,
}));
